const en = {
  empty_list: 'No message has been found',
  category_name: 'Category: {{categoryName}}',
  exit: 'Exit',
  empty_user_hint_1: 'Please create a ticket for your request, for the first ticket, click',
  here: 'here',
  empty_user_hint_2: '',
  create_new_ticket: '+ New Ticket',
  status: 'status:',
  all: 'All',
  next: 'Next',
  creating_new_ticket: 'Create New Ticket',
  new_ticket_help: 'Select your ticket category carefully, then explain your request in a 3-minute voice message.',
  search_user: 'Search user',
  help: 'Help'
}

export  default en
